/*
 * Copyright 2026 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Container } from '@backstage/ui';
import { TechDocsReaderHeader } from './TechDocsReaderHeader';
import { TechDocsReaderEntityCard } from './TechDocsReaderEntityCard';
import { TechDocsReaderPageSubheader } from '../../reader/components/TechDocsReaderPageSubheader';
import { TechDocsReaderContent } from './TechDocsReaderContent';

export type TechDocsReaderLayoutProps = {
  withHeader?: boolean;
  withSearch?: boolean;
};

export const TechDocsReaderLayout = (props: TechDocsReaderLayoutProps) => {
  const { withSearch, withHeader = true } = props;
  return (
    <>
      {withHeader && <TechDocsReaderHeader withSearch={withSearch} />}
      <Container mt="6">
        <TechDocsReaderEntityCard withSearch={!withHeader && withSearch} />
        <TechDocsReaderPageSubheader />
        <TechDocsReaderContent />
      </Container>
    </>
  );
};
